import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrTicketCategory.ts
var t = () => e("ticketCategory");
//#endregion
export { t as useTrTicketCategory };
